module.exports = __webpack_public_path__ + "img/R05v.cbf3a158.png";